import { render, staticRenderFns } from "./teacherChipView.vue?vue&type=template&id=770ee406&"
import script from "./teacherChipView.vue?vue&type=script&lang=js&"
export * from "./teacherChipView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports